import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({ baseURL: BACKEND_URL ? `${BACKEND_URL}/api` : undefined, withCredentials: true });

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("bamf_admin_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const formatPrice = (n) =>
  typeof n === "number" ? new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(n) : null;

export function errorText(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(d);
}

export const CONTACT = {
  phone: "616-550-8399",
  phoneHref: "tel:+16165508399",
  email: "sales@bamfsaws.com",
  location: "Grand Rapids, Michigan, USA",
};
